<script>
    import { createEventDispatcher } from "svelte";

    import { getArtworkURL } from "../utils.js";

    export let item;

    let img;

    const dispatch = createEventDispatcher();

    $: attrs = item.attributes;
    $: artworkUrl = getArtworkURL(item, 150, 150) || '/missing-artwork.svg';

    const music = MusicKit.getInstance();

    function handleDragStart(event) {
        console.log("item dragged", item);
        event.dataTransfer.clearData();
        event.dataTransfer.setData("application/json", JSON.stringify({ id: item.id, type: item.type }));
        event.dataTransfer.setDragImage(img, img.width / 2, img.height / 2);
    }

    let root;
    function handleContextMenu({ pageX, pageY }) {
        dispatch("context-menu", { pageX, pageY, target: root });
    }
</script>

<div class="root" on:click on:contextmenu|preventDefault={handleContextMenu}>
    {#if item.type == "albums" || item.type == "library-albums"}
        <div class="entry-container"
             draggable="true"
             on:dragstart={handleDragStart}
             bind:this={root}>
            <div class="entry">
                <img src="{artworkUrl}"
                     alt="{attrs.artistName} - {attrs.name}"
                     width="150"
                     height="150"
                     draggable="false"
                     bind:this={img}>
                <div class="infos">
                    <div class="title" title="{attrs.name}">{attrs.name}</div>
                    {#if attrs.artistName}
                        <div class="subtitle" title="{attrs.artistName}">{attrs.artistName}</div>
                    {:else}
                        <br/>
                    {/if}
                </div>
            </div>
        </div>
    {:else if item.type == "playlists" || item.type == "library-playlists"}
        <div class="entry-container"
             draggable="true"
             on:dragstart={handleDragStart}
             bind:this={root}>
            <div class="entry">
                <img src="{artworkUrl}"
                     alt="{attrs.name}"
                     width="150"
                     height="150"
                     draggable="false">
                <div class="infos">
                    <div class="title" title="{attrs.name}">{attrs.name}</div>
                    <div class="subtitle">Personal playlist</div>
                </div>
            </div>
        </div>
    {/if}
</div>

<style>
    .entry-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        padding: 5px;
        border-radius: 5px;
        cursor: pointer;
        box-sizing: border-box;
    }

    .entry {
        display: grid;
        grid-gap: 10px;
        grid-template-rows: repeat(2, auto);
        grid-template-columns: 1fr;
        transition: transform 0.2s;
    }

    .entry > img {
        border-radius: 3px;
        box-shadow: var(--app-box-shadow);
    }

    .entry-container:hover > .entry,
    .entry-container:global(.context-menu-active) > .entry {
        transform: scale(1.1);
    }

    .entry-container:hover > .entry > img,
    .entry-container:global(.context-menu-active) > .entry > img {
        filter: brightness(1.2);
    }

    .infos {
        width: 150px;
    }

    .title {
        font-size: 15px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .subtitle {
        font-size: 14px;
        color: var(--app-secondary-fg-color);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    
    .entry-container:global(.context-menu-active) .title {
        color: var(--app-dark-fg-color);
    }
    
    .entry-container:global(.context-menu-active) .subtitle {
        color: var(--app-dark-secondary-fg-color);
    }
</style>
